import React, { Component } from "react";
import "./index.css";

class HamburgerMenu extends Component {
  render() {
    return (
      <div className={`-nav-icon ${this.props.open ? "open" : ""}`} onClick={this.props.toggleMenu}>
        <span />
        <span />
        <span />
        <span />
      </div>
    );
  }
}

export default HamburgerMenu;



// WEBPACK FOOTER //
// ./src/components/Header/Components/HamburgerMenu/index.js